import { ARROW_BUTTON } from "@/src/lib/SmartDB/Commons/Constants/images";
import NextLink from 'next/link';
import styles from './OpenInNewTabButton.module.scss';
export default function OpenInNewTabButton({ url }: { url: string }) {
    return (
        <NextLink href={url} legacyBehavior>
            <a target="_blank" rel="noopener noreferrer">
                <svg width="19" height="19" className={styles.icon}>
                    <use href={ARROW_BUTTON}></use>
                </svg>
            </a>
        </NextLink>
    );
}
